import React, { useState, useEffect } from "react";

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const [pageWindow, setPageWindow] = useState([1, 5]); // [start, end]

  // ✅ อัปเดตช่วงหน้าเมื่อเปลี่ยน currentPage
  useEffect(() => {
    const start = Math.floor((currentPage - 1) / 5) * 5 + 1;
    const end = Math.min(start + 4, totalPages);
    setPageWindow([start, end]);
  }, [currentPage, totalPages]);

  // ✅ สร้าง list ของ page numbers ตามช่วง
  const pages = [];
  for (let i = pageWindow[0]; i <= pageWindow[1]; i++) {
    pages.push(i);
  }

  // ✅ handle ปุ่ม next window
  const handleNextWindow = () => {
    if (pageWindow[1] < totalPages) {
      const newStart = pageWindow[1] + 1;
      const newEnd = Math.min(newStart + 4, totalPages);
      setPageWindow([newStart, newEnd]);
      onPageChange(newStart);
    }
  };

  // ✅ handle ปุ่ม previous window
  const handlePrevWindow = () => {
    if (pageWindow[0] > 1) {
      const newStart = Math.max(pageWindow[0] - 5, 1);
      const newEnd = newStart + 4;
      setPageWindow([newStart, newEnd]);
      onPageChange(newEnd);
    }
  };

  return (
    <div className="flex justify-center sm:justify-end mt-6 w-full">
      <div
        className="flex items-center gap-2 bg-white dark:bg-gray-900 border border-gray-200 
                   dark:border-gray-700 px-2 py-2 rounded-md shadow-sm 
                   overflow-x-auto scrollbar-thin scrollbar-thumb-gray-400 
                   dark:scrollbar-thumb-gray-600 scrollbar-thumb-rounded-full 
                   max-w-full transition-colors duration-300"
      >
        {/* Previous window */}
        <button
          onClick={handlePrevWindow}
          disabled={pageWindow[0] === 1}
          className="flex-shrink-0 px-3 py-1 rounded-md text-sm font-medium
                     bg-gray-100 text-gray-700 hover:bg-gray-200
                     dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700
                     disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          Prev
        </button>

        {/* Page numbers (5 per window) */}
        <div className="flex items-center gap-1 flex-nowrap">
          {pages.map((page) => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`flex-shrink-0 px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 ${
                page === currentPage
                  ? "bg-indigo-500 text-white shadow-sm dark:bg-indigo-600"
                  : "bg-gray-100 text-gray-700 hover:bg-indigo-100 hover:text-indigo-700 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-indigo-900/40 dark:hover:text-indigo-300"
              }`}
            >
              {page}
            </button>
          ))}
        </div>

        {/* Next window */}
        <button
          onClick={handleNextWindow}
          disabled={pageWindow[1] >= totalPages}
          className="flex-shrink-0 px-3 py-1 rounded-md text-sm font-medium
                     bg-gray-100 text-gray-700 hover:bg-gray-200
                     dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700
                     disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
